<template>
  <!-- 面包屑组件 -->
  <div class="bread-wrap" :class="{ chance2: route.name == 'userCenter', chance3: route.name == 'orderList' }">
    <img src="../../assets/img/icons/icon-back-arr.png" class="back" @click="router.go(-1)">
    <div class="right">
      <span class="txt" v-for="(item, index) in breadcrumb" :key="index">{{ $t(item.meta.title) }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute();

const routes = computed(() => {
  return router.options.routes.filter(item => item.meta.showInbreadcrumb);
});

const breadcrumb = computed(() => {
  // 根据路由配置meta中的showInbreadcrumb字段过滤
  let matchedArr = route.matched.filter((item) => {
    return item.meta.showInbreadcrumb
  });
  return matchedArr;
})
</script>

<style scoped>
.bread-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 1.77083vw 2.5vw;
}

.bread-wrap.chance {
  padding-bottom: 0;
}

.bread-wrap.chance2 {
  position: absolute;
  z-index: 100;
}

.bread-wrap .back {
  display: block;
  width: 2.08333vw;
  flex-shrink: 0;
  margin-right: 0.83333vw;
  cursor: pointer;
}

.bread-wrap .right {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}

.bread-wrap .right .txt {
  font-size: 1.25vw;
  line-height: 1;
  color: #171A41;
  cursor: pointer;
}

.bread-wrap .right .txt::before {
  display: inline-block;
  content: ">";
  font-size: 1.25vw;
  line-height: 1;
  color: #171A41;
  margin: 0 0.41666vw;
}

.bread-wrap .right .txt:first-of-type {
  font-size: 1.66666vw;
  color: #B41D23;
  font-weight: bold;
  cursor: default;
}

.bread-wrap .right .txt:first-of-type::before {
  display: none;
}

@media screen and (max-width: 750px) {

  .bread-wrap {
    padding: 2.4vw 4.26666vw;
  }

  .bread-wrap.chance3 {
    padding: 5.86666vw 4.26666vw;
  }

  .bread-wrap .back {
    width: 5.33333vw;
    margin-right: 2.13333vw;
  }

  .bread-wrap .right .txt:first-of-type {
    font-size: 5.33333vw;
    line-height: 7.46666vw;
  }

  .bread-wrap .right .txt {
    font-size: 3.73333vw;
  }

  .bread-wrap .right .txt::before {
    font-size: 3.73333vw;
    margin: 0 1.33333vw;
  }

}
</style>
